import Head from 'next/head';
import { GetServerSideProps } from 'next';
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import jwt from 'jsonwebtoken';
import styles from '../../styles/Home.module.css';
import Wizard from '../../components/Wizard';

type Props = {
  decoded: {
    tenant: string;
    host: string;
    store: number;
    iat: number;
  };
  token: string;
};

const AuditWidget = ({ decoded, token }: Props): JSX.Element => {
  const client = new ApolloClient({
    ssrMode: typeof window === 'undefined',
    uri: `https://${decoded.host}/public_graphql`,
    cache: new InMemoryCache(),
    headers: {
      ['X-RS-TOKEN']: token,
      ['Access-Control-Allow-Credentials']: 'true',
    },
  });

  return (
    <ApolloProvider client={client}>
      <Head>
        <title>Audit Widget</title>
      </Head>

      <main className={styles.main}>
        <Wizard />
      </main>
    </ApolloProvider>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { token } = context.params;
  const decoded = jwt.verify(token as string, process.env.PUBLIC_GQL_SECRET, {
    algorithms: ['HS256'],
  });

  return { props: { decoded, token } };
};

export default AuditWidget;
